import { FieldNameEnum, RelatedDataEntity } from '@mark43/cad-api';
import { createCell, SimpleTable } from '../../../common/components/simple-table';
import { generateRowData } from './generate-row-data';
import { useOpenDepartmentLink } from '../../../layout/use-open-department-link';
import { useBootstrapState } from '../../../bootstrap/bootstrap-provider';
import { FR_EVENT_DETAILS_TABS } from '../../../fr-event-details-page/constants';
import { useOpenEvent } from '../../../common/hooks/use-open-event';

const tableStyles = [{ whiteSpace: 'nowrap' as const }, {}, { whiteSpace: 'nowrap' as const }];

export const CadEventsTable = ({ cadEvents }: { cadEvents: RelatedDataEntity[] }) => {
    const openEventHandler = useOpenEvent();

    const cadEventsRows = [
        [
            createCell({ content: 'Created' }),
            createCell({ content: 'CFS / Narrative' }),
            createCell({ content: 'Event #' }),
        ],
        ...generateRowData(cadEvents, (eventId) =>
            openEventHandler({ eventId, frEventDetailsTabName: FR_EVENT_DETAILS_TABS.EVENT_INFO })
        ),
    ];

    return (
        <SimpleTable
            columnStyles={tableStyles}
            rows={cadEventsRows}
            emptyState="No CAD Events Found"
            hasBorders={false}
        />
    );
};

export const RmsHistoryTable = ({ rmsReports }: { rmsReports: RelatedDataEntity[] }) => {
    const openDepartmentLink = useOpenDepartmentLink();
    const { fieldDisplayNameByFieldName: fieldDisplayNames } = useBootstrapState();
    const renDisplayName =
        fieldDisplayNames[FieldNameEnum.AGENCY_EVENT_REPORTING_EVENT_NUMBER.name];

    const rmsHistoryRows = [
        [
            createCell({ content: 'Created' }),
            createCell({ content: 'Report Type / Class' }),
            createCell({ content: `${renDisplayName} / Owner` }),
        ],
        ...generateRowData(rmsReports, (entityId) => {
            openDepartmentLink({
                path: `/reports/${entityId}`,
                app: 'RMS',
                tenantStrategy: 'PREFER_RMS_TENANT',
            });
        }),
    ];

    return (
        <SimpleTable
            columnStyles={tableStyles}
            rows={rmsHistoryRows}
            emptyState="No RMS Reports Found"
            hasBorders={false}
        />
    );
};

export const VehiclesTable = ({ vehicles }: { vehicles: RelatedDataEntity[] }) => {
    const openDepartmentLink = useOpenDepartmentLink();
    const { fieldDisplayNameByFieldName: fieldDisplayNames } = useBootstrapState();
    const renDisplayName =
        fieldDisplayNames[FieldNameEnum.AGENCY_EVENT_REPORTING_EVENT_NUMBER.name];

    const vehiclesRows = [
        [
            createCell({ content: 'Created' }),
            createCell({ content: 'Report Type / Class' }),
            createCell({ content: `${renDisplayName} / Owner` }),
        ],
        ...generateRowData(vehicles, (entityId) => {
            openDepartmentLink({
                path: `/reports/${entityId}`,
                app: 'RMS',
                tenantStrategy: 'PREFER_RMS_TENANT',
            });
        }),
    ];

    return (
        <SimpleTable
            columnStyles={tableStyles}
            rows={vehiclesRows}
            emptyState="No Related Vehicles Found"
            hasBorders={false}
        />
    );
};
